// Import the functions you need from the SDKs you need


const firebaseConfig = {
    apiKey: "AIzaSyBkElVxMylMn64fXivqlfdeoGJ_AcbDI2s",
    authDomain: "jambuspace-b3e6f.firebaseapp.com",
    projectId: "jambuspace-b3e6f",
    storageBucket: "jambuspace-b3e6f.appspot.com",
    messagingSenderId: "255379385133",
    appId: "1:255379385133:web:8a2a9e79ea2ef5c60241a4",
    measurementId: "G-01DLCEEW9P"
};
export default firebaseConfig;
